export const DOMAIN_TYPES = {
  PAAS: 'paas',
  SAAS: 'saas',
  CLIENT: 'client',
  APP: 'app',
  UNKNOWN: 'unknown'
};

export const SUBDOMAIN_PREFIXES = {
  paas: DOMAIN_TYPES.PAAS,
  admin: DOMAIN_TYPES.PAAS,
  saas: DOMAIN_TYPES.SAAS,
  client: DOMAIN_TYPES.CLIENT,
  tenant: DOMAIN_TYPES.CLIENT,
  app: DOMAIN_TYPES.APP
};

export function parseSubdomain(hostname) {
  const parts = hostname.split('.');

  if (parts.length >= 2) {
    const prefix = parts[0].toLowerCase();
    if (SUBDOMAIN_PREFIXES[prefix]) {
      return {
        prefix,
        type: SUBDOMAIN_PREFIXES[prefix],
        isMultiLevel: parts.length > 2
      };
    }
  }

  return {
    prefix: null,
    type: DOMAIN_TYPES.UNKNOWN,
    isMultiLevel: false
  };
}

export function detectDomainType(hostname) {
  const parsed = parseSubdomain(hostname);
  return parsed.type;
}

export function getRouteForDomainType(type, paasId = null, saasId = null, tenantId = null) {
  switch (type) {
    case DOMAIN_TYPES.PAAS:
      return '/paas-admin/login';
    case DOMAIN_TYPES.SAAS:
      return '/saas-admin/login';
    case DOMAIN_TYPES.CLIENT:
      return '/client-admin/login';
    case DOMAIN_TYPES.APP:
      return '/login';
    default:
      return '/';
  }
}

export const LANDING_PAGE_DOMAINS = {
  'cultisgo.com': {
    key: 'cultisgo',
    name: 'CultisGo',
    type: DOMAIN_TYPES.PAAS,
    branding: {
      primaryColor: '#7c3aed',
      accentColor: '#22d3ee',
      logo: null,
      companyName: 'CultisGo'
    }
  },
  'nevixa.in': {
    key: 'nevixa',
    name: 'Nevixa',
    type: DOMAIN_TYPES.PAAS,
    branding: {
      primaryColor: '#6366f1',
      accentColor: '#06b6d4',
      logo: null,
      companyName: 'Nevixa'
    }
  }
};

export function getLandingPageConfig(hostname) {
  if (!hostname) return null;
  const cleanHost = hostname.split(':')[0].toLowerCase();
  return LANDING_PAGE_DOMAINS[cleanHost] || null;
}

export function isLandingPageDomain(hostname) {
  return getLandingPageConfig(hostname) !== null;
}

export function getLoginContext(type, paasId, saasId, tenantId) {
  return {
    paasId: paasId || null,
    saasId: saasId || null,
    tenantId: tenantId || null,
    level: type
  };
}

export function storeDomainSession(domainData) {
  const session = {
    type: domainData.type,
    paasId: domainData.paasId,
    saasId: domainData.saasId,
    tenantId: domainData.tenantId,
    branding: domainData.branding,
    timestamp: Date.now(),
    isCustomDomain: domainData.isCustomDomain || false,
    customDomain: domainData.customDomain || null
  };
  localStorage.setItem('domainSession', JSON.stringify(session));
  return session;
}

export function getStoredDomainSession() {
  try {
    const stored = localStorage.getItem('domainSession');
    if (!stored) return null;

    const session = JSON.parse(stored);
    const maxAge = 30 * 60 * 1000;
    if (Date.now() - session.timestamp > maxAge) {
      localStorage.removeItem('domainSession');
      return null;
    }

    return session;
  } catch {
    return null;
  }
}

export function clearDomainSession() {
  localStorage.removeItem('domainSession');
}

export default {
  parseSubdomain,
  detectDomainType,
  getRouteForDomainType,
  getLoginContext,
  storeDomainSession,
  getStoredDomainSession,
  clearDomainSession,
  DOMAIN_TYPES,
  SUBDOMAIN_PREFIXES
};